/* Chrome's `:focus-visible` also matches focus that script moves, as Radix does
 * when a dialog opens on its first button, so a mouse click left a focus ring
 * on that button. Recording the last input lets portal.css keep focus rings
 * for keyboard users only. */
export const INPUT_MODALITY_ATTRIBUTE = 'data-input-modality';

const setModality = (modality: 'pointer' | 'keyboard') => {
  document.documentElement.setAttribute(INPUT_MODALITY_ATTRIBUTE, modality);
};

/* Modifier presses alone (e.g. cmd while clicking) aren't keyboard navigation. */
const MODIFIER_KEYS = new Set(['Meta', 'Control', 'Alt', 'Shift']);

export const trackInputModality = () => {
  const options = { capture: true, passive: true };
  document.addEventListener('pointerdown', () => setModality('pointer'), options);
  document.addEventListener(
    'keydown',
    event => {
      if (!MODIFIER_KEYS.has(event.key)) setModality('keyboard');
    },
    options,
  );
};
